import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="attr" id="attr"></a>
    <h1 {...{
      "id": "windowattr"
    }}>{`window.Attr`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Attr"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Attr`}</a>{`  `}</p>
    <a name="new-attr-new" id="new-attr-new"></a>
    <h2 {...{
      "id": "attrdocument-nodename"
    }}>{`Attr(document, nodeName)`}</h2>
    <p>{`Creates an instance of Attr.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`document`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Document`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`nodeName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="attr-nodename" id="attr-nodename"></a>
    <h2 {...{
      "id": "nodename--string"
    }}>{`nodeName : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="attr-localname" id="attr-localname"></a>
    <h2 {...{
      "id": "localname--string"
    }}>{`localName : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="attr-name" id="attr-name"></a>
    <h2 {...{
      "id": "name--string"
    }}>{`name : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="attr-specified" id="attr-specified"></a>
    <h2 {...{
      "id": "specified--boolean"
    }}>{`specified : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="attr-value" id="attr-value"></a>
    <h2 {...{
      "id": "value--"
    }}>{`value : `}<inlineCode parentName="h2">{`*`}</inlineCode></h2>
    <a name="attr-nodetype" id="attr-nodetype"></a>
    <h2 {...{
      "id": "nodetype--number"
    }}>{`nodeType : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="attr-nodevalue" id="attr-nodevalue"></a>
    <h2 {...{
      "id": "nodevalue--"
    }}>{`nodeValue : `}<inlineCode parentName="h2">{`*`}</inlineCode></h2>
    <a name="attr-ownerelement" id="attr-ownerelement"></a>
    <h2 {...{
      "id": "ownerelement--element"
    }}>{`ownerElement : `}<inlineCode parentName="h2">{`Element`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-contenteditable" id="node-contenteditable"></a>
    <h2 {...{
      "id": "contenteditable"
    }}>{`contentEditable`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-isconnected" id="node-isconnected"></a>
    <h2 {...{
      "id": "isconnected--boolean"
    }}>{`isConnected : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-parentnode" id="node-parentnode"></a>
    <h2 {...{
      "id": "parentnode--node"
    }}>{`parentNode : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-parentelement" id="node-parentelement"></a>
    <h2 {...{
      "id": "parentelement--element"
    }}>{`parentElement : `}<inlineCode parentName="h2">{`Element`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-firstchild" id="node-firstchild"></a>
    <h2 {...{
      "id": "firstchild--node"
    }}>{`firstChild : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-lastchild" id="node-lastchild"></a>
    <h2 {...{
      "id": "lastchild--node"
    }}>{`lastChild : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-previoussibling" id="node-previoussibling"></a>
    <h2 {...{
      "id": "previoussibling--node"
    }}>{`previousSibling : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-nextsibling" id="node-nextsibling"></a>
    <h2 {...{
      "id": "nextsibling--node"
    }}>{`nextSibling : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-firstelementchild" id="node-firstelementchild"></a>
    <h2 {...{
      "id": "firstelementchild--node"
    }}>{`firstElementChild : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-lastelementchild" id="node-lastelementchild"></a>
    <h2 {...{
      "id": "lastelementchild--node"
    }}>{`lastElementChild : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-previouselementsibling" id="node-previouselementsibling"></a>
    <h2 {...{
      "id": "previouselementsibling--node"
    }}>{`previousElementSibling : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-nextelementsibling" id="node-nextelementsibling"></a>
    <h2 {...{
      "id": "nextelementsibling--node"
    }}>{`nextElementSibling : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-textcontent" id="node-textcontent"></a>
    <h2 {...{
      "id": "textcontent--string"
    }}>{`textContent : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <a name="node-childnodes" id="node-childnodes"></a>
    <h2 {...{
      "id": "childnodes--nodelist"
    }}>{`childNodes : `}<inlineCode parentName="h2">{`NodeList`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-children" id="node-children"></a>
    <h2 {...{
      "id": "children--htmlcollection"
    }}>{`children : `}<inlineCode parentName="h2">{`HTMLCollection`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-ownerdocument" id="node-ownerdocument"></a>
    <h2 {...{
      "id": "ownerdocument"
    }}>{`ownerDocument`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="node-attributes" id="node-attributes"></a>
    <h2 {...{
      "id": "attributes"
    }}>{`attributes`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="attr-remove" id="attr-remove"></a>
    <h2 {...{
      "id": "remove"
    }}>{`remove()`}</h2>
    <a name="node-haschildnodes" id="node-haschildnodes"></a>
    <h2 {...{
      "id": "haschildnodes"
    }}>{`hasChildNodes()`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{`  `}</p>
    <a name="node-clonenode" id="node-clonenode"></a>
    <h2 {...{
      "id": "clonenodedeep"
    }}>{`cloneNode(deep)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`deep`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-appendchild" id="node-appendchild"></a>
    <h2 {...{
      "id": "appendchildchild"
    }}>{`appendChild(child)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`child`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-insertbefore" id="node-insertbefore"></a>
    <h2 {...{
      "id": "insertbeforechild-before"
    }}>{`insertBefore(child, before)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`child`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`before`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-replacechild" id="node-replacechild"></a>
    <h2 {...{
      "id": "replacechildnewchild-oldchild"
    }}>{`replaceChild(newChild, oldChild)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`newChild`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`oldChild`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-removechild" id="node-removechild"></a>
    <h2 {...{
      "id": "removechildchild"
    }}>{`removeChild(child)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`child`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-before" id="node-before"></a>
    <h2 {...{
      "id": "beforenodes"
    }}>{`before(...nodes)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...nodes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<Node>`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-after" id="node-after"></a>
    <h2 {...{
      "id": "afternodes"
    }}>{`after(...nodes)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...nodes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<Node>`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-replacewith" id="node-replacewith"></a>
    <h2 {...{
      "id": "replacewithnodes"
    }}>{`replaceWith(...nodes)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...nodes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<Node>`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="node-contains" id="node-contains"></a>
    <h2 {...{
      "id": "containsnode"
    }}>{`contains(node)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`node`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Node`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="eventtarget-addeventlistener" id="eventtarget-addeventlistener"></a>
    <h2 {...{
      "id": "addeventlistenereventname-callback-capture"
    }}>{`addEventListener(eventName, callback, `}{`[capture]`}{`)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`eventName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`callback`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[capture]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="eventtarget-removeeventlistener" id="eventtarget-removeeventlistener"></a>
    <h2 {...{
      "id": "removeeventlistenereventname-callback-capture"
    }}>{`removeEventListener(eventName, callback, `}{`[capture]`}{`)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`eventName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`callback`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[capture]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="eventtarget-dispatchevent" id="eventtarget-dispatchevent"></a>
    <h2 {...{
      "id": "dispatcheventevent"
    }}>{`dispatchEvent(event)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`event`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      